/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import { Checkbox } from 'antd'
import MultiSelectPane from './MultiSelectorPane'
import { FullHeightSizer } from './../screen-util'
import { sortBy } from 'ramda'

const MemoizedCheckBox = React.memo(({ children, onToggle, id, ...props }) => (
  <Checkbox onChange={() => onToggle(id)} {...props}>
    {children}
  </Checkbox>
))

const FlexWrapMultiSelectPane = ({
  data,
  selectedIds,
  setSelectedIds,
  toDisplay,
  toId,
  acceptFilter,
  contentHeightOffset = 350,
  itemWidth = '250px',
  itemStyle,
  itemStyleFunc = _ => {},
  renderFilters,
}) => {
  const sort = sortBy(d => toDisplay(d))
  return (
    <MultiSelectPane
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      data={data}
      toId={toId}
      acceptFilter={acceptFilter}
      renderFilters={renderFilters}
      renderContent={({ data, toggleId, selectedIds }) => (
        <FullHeightSizer heightOffset={contentHeightOffset}>
          {({ width, height }) => (
            <div
              style={{
                overflow: 'auto',
                width: `${width}px`,
                height: `${height}px`,
                display: 'flex',
                flexWrap: 'wrap',
                alignContent: 'flex-start',
                justifyContent: 'flex-start',
              }}
            >
              {sort(data).map(item => (
                <div
                  key={toId(item)}
                  css={{
                    width: itemWidth,
                    height: '20px',
                    overflow: 'hidden',
                    marginBottom: '6px',
                    ...itemStyle,
                  }}
                  title={toDisplay(item)}
                >
                  <MemoizedCheckBox
                    key={toId(item)}
                    checked={selectedIds.includes(toId(item))}
                    id={toId(item)}
                    onToggle={toggleId}
                    style={{ ...itemStyleFunc(item) }}
                  >
                    {toDisplay(item)}
                  </MemoizedCheckBox>
                </div>
              ))}
            </div>
          )}
        </FullHeightSizer>
      )}
    />
  )
}

export default FlexWrapMultiSelectPane
